export default __webpack_public_path__ + "static/media/decouvrez.5f752f2d.jpg";